export default __webpack_public_path__ + "static/media/fingerPrint.4939d266.gif";